import { render, staticRenderFns } from "./AdministrationOrders.vue?vue&type=template&id=75cd709e&scoped=true&"
import script from "./AdministrationOrders.vue?vue&type=script&lang=js&"
export * from "./AdministrationOrders.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationOrders.vue?vue&type=style&index=0&id=75cd709e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd709e",
  null
  
)

export default component.exports